// Origin
import { OriginSize } from "shared/origin";
import { GameHeaderStorage, GameViewStorage, MapStorage } from "shared/storages";
import { Main } from "screens/main";
import { Game } from "screens";
import { EventBus } from "shared/emmiter";
import { SettingConfig } from "shared/config";
import { PopupsService } from "./popups.service";

// y = clientHeight - gamePool.height - margin

export class ResizeService {
    public proportion = 1;
    private externalHeaderHeight = 37;

    public resizeScene(app: PIXI.Application): void {
        const canvas = app.view;
        const canvasPos = canvas.getBoundingClientRect();
        const map = MapStorage.map;

        const header = GameHeaderStorage.header;
        const gamePool = GameViewStorage.gamePool;
        const animContainer: PIXI.Container = Main.instance.app.stage.getChildByName('animation_container') as PIXI.Container;
        const bar: PIXI.Container = GameViewStorage.bar;
        const popups = Game.instance.popups;
        const productCounter: PIXI.Container = GameViewStorage.productCounter;

        const assetsProportion: number = OriginSize.height / OriginSize.width;//2.16

        const clientWidth: number = window.screen.availWidth;//document.documentElement.clientWidth;//414
        const clientHeight: number = window.screen.availHeight;//document.documentElement.clientHeight; //736
        const divApp = document.querySelector('.app');
        
        const screenProportions: number = divApp.clientHeight / divApp.clientWidth;
        // const screenProportions: number = clientHeight / clientWidth;

        const headerProportion = this.externalHeaderHeight * (OriginSize.height / canvas.offsetHeight);

        const canvasW = clientWidth;
        const canvasH = canvasW * assetsProportion;
        const devicePixelRatio = OriginSize.height / clientHeight;

        // const test = window.screen.height - clientHeight;
        const userAgent = navigator.userAgent.toLowerCase();
        const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

        const testProportion = assetsProportion - screenProportions;
        
        document.getElementById('tutorial').style.width = `${canvas.offsetWidth}px`;
        document.getElementById('mapMenu').style.width = `${canvas.offsetWidth}px`;
        document.getElementById('mapMenu').style.left = `${canvasPos.left}px`;
        // document.getElementById('mapBtn').style.left = `${canvasPos.left + canvas.offsetWidth / 2 - document.getElementById('mapBtn').offsetWidth / 2}px`;
        // 3190
        MapStorage.screenHeight = OriginSize.width * screenProportions;
        if (clientWidth < 823) {
            if (GameHeaderStorage.header) {
                // GameHeaderStorage.header.y = headerProportion;
            }

            GameViewStorage.mechanicShift = 100;
        }

        if (clientWidth < 823 && !isTablet) {
            MapStorage.screenHeight = OriginSize.width * screenProportions;
            if (Math.abs(testProportion) <= 0.1) {
                if (map) {
                    map.y = -3100;
                    MapStorage.plus = 180;
                    if (clientHeight - window.innerHeight > 150) {
                        map.y = -3600;
                        MapStorage.plus = 420;
                    }

                    EventBus.emit('plus_map');
                }

                if (gamePool) {
                    gamePool.y = 700;
                }

                if (animContainer) {
                    animContainer.y = gamePool.y;
                }

                if (bar) {
                    bar.y = GameViewStorage.originBarY;
                }

                if (popups) {
                    popups.win.popup.y = popups.win.origin.y;
                    popups.lose.popup.y = popups.lose.origin.y;
                    popups.reward.popup.y = popups.reward.origin.y;
                }

                if (productCounter) {
                    productCounter.y = GameViewStorage.productCounterOriginY;
                }

            } else {
                // alert(2)
                
                if (map) {
                    map.y = -3350;
                    MapStorage.plus = 310;
                    
                    
                    EventBus.emit('plus_map');
                }

                if (gamePool) {
                    gamePool.y = 640;
                }

                if (animContainer) {
                    animContainer.y = gamePool.y;
                }

                if (bar) {
                    bar.y = -60;
                }

                PopupsService.popupY = 1100;

                if (productCounter) {
                    productCounter.y = 400;
                }

            }

        } else {
            MapStorage.screenHeight = clientHeight * devicePixelRatio;
            EventBus.emit('plus_map');
        } 

    }
}